import {
    AvatarUnits,
    Nullable,
    OutwardReferralData,
    RecommendationData,
    ReferralData,
    ReservationDataWithAssociatedServices,
    TaskData,
} from 'chaika-frontend-types/frontend-cms';
import { EntryListParams } from '@patient/store/ehr/models/EntryList';
import { GroupedListParams } from '@store/abstract/GroupedList';
import { DrugList } from '@store/models/SystemFields/Drug';

export interface GroupedItems {
    title?: string;
    currentItemId?: string;
    items: ItemParams[];
}

export interface ItemParams {
    type: ItemType;
    id: string;
    isExpired: boolean;
    isExecuted?: boolean;
    count?: number;
    startDate?: string;
    endDate?: Nullable<string>;
    hideOnPrint?: boolean;
}

export interface ReferralItemParams {
    type: ItemType;
    id: string;
    isExpired: boolean;
    referralId: string;
    serviceId: string;
    isExecuted?: boolean;
    count?: number;
    startDate?: string;
    endDate?: Nullable<string>;
}

export const enum ItemType {
    Referral = 'referral',
    Task = 'task',
    Recommendation = 'recommendation',
    Drug = 'drug',
    Entry = 'entry',
    OutwardReferral = 'outwardReferral',
    Reservation = 'reservation',
}

export const TREATMENT_PLAN_MAX_HEIGHT = 500;

export interface Author {
    name: string;
    role: string;
    avatar?: string;
    avatarUnits?: AvatarUnits;
}

export interface TreatmentPlanItems {
    reservations: ReservationDataWithAssociatedServices[];
    tasks: TaskData[];
    entries: EntryListParams[];
    referrals: GroupedListParams<ReferralData, string>[];
    drugs: string[];
    recommendations: RecommendationData[];
    outwardReferrals: OutwardReferralData[];
    drugList: DrugList;
}
